import { Link } from "@tanstack/react-router";
import { originLinkSearch } from "@/lib/detail-origin";

/**
 * The roles that require a given capability (skill or competency), each linking
 * to its role page. Each link carries the capability as origin so the role page
 * can breadcrumb / link straight back here — the reverse of the Role → Skill /
 * Role → Competency links in RoleRequirementsEditor.
 *
 * Presentational: the roles array is already delivered on the skill/competency
 * detail payload (`.roles`), so there's no fetch here.
 */
export function RequiredByRolesSection({
  roles,
  originKind,
  entityId,
  entityName,
}: {
  roles: { id: string; name: string }[];
  originKind: "skill" | "competency";
  entityId: string;
  entityName: string;
}) {
  if (roles.length === 0) {
    return <p className="text-sm text-muted-foreground">No roles require this yet.</p>;
  }

  return (
    <ul className="space-y-2">
      {roles.map((role) => (
        <li key={role.id}>
          <Link
            to="/dashboard/roles/$roleId"
            params={{ roleId: role.id }}
            search={originLinkSearch(originKind, entityId, entityName)}
            className="block truncate rounded-md border bg-card px-3 py-2 text-sm font-medium text-foreground transition-colors hover:bg-accent"
          >
            {role.name}
          </Link>
        </li>
      ))}
    </ul>
  );
}
